<template>
  <el-container>
    <el-aside class="layout_left_menu_box">
      <div class="hshow t_c flex-center" v-if="!platformInfo.icon">
        <img src="~@/assets/public/hshow.png" />
      </div>
      <div class="hshow hshow_1 t_c flex-center" v-else>
        <img :src="platformInfo.icon" />
        <span>{{ platformInfo.name }}</span>
      </div>
      <el-menu default-active="1-4-1" class="el-menu-vertical-demo" text-color="#fff" background-color="#2f3447" @open="handleOpen" @close="handleClose" :collapse="isCollapse" :router="true" :unique-opened="true">
        <el-menu-item index="/">
          <i class="icon-col el-icon-menu"></i>
          <span slot="title">{{ $t('menu.overview') }}</span>
        </el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <i class="icon-col el-icon-s-order"></i>
            <span slot="title">{{ $t('menu.order') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="orderlist">{{ $t('menu.orderList') }}</el-menu-item>
            <el-menu-item index="orderSeting">{{ $t('menu.revokeOrder') }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class="icon-col el-icon-s-custom"></i>
            <span slot="title">{{ $t('menu.rider') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="riderlist">{{ $t('menu.riderList') }}</el-menu-item>
            <el-menu-item index="riderauthentication">{{ $t('menu.riderAuth') }}</el-menu-item>
            <el-menu-item index="riderlevel">{{ $t('menu.riderLevel') }}</el-menu-item>
            <el-menu-item index="riderset">{{ $t('menu.riderSet') }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">
            <i class="icon-col el-icon-s-shop"></i>
            <span slot="title">{{ $t('menu.store') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="storelist">{{ $t('menu.storeList') }}</el-menu-item>
            <el-menu-item index="storevalue">{{ $t('menu.storeValue') }}</el-menu-item>
            <el-menu-item index="distributionset">{{ $t('menu.priceSet') }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <i class="icon-col el-icon-s-finance"></i>
            <span slot="title">{{ $t('menu.finance') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="riderzl">{{ $t('menu.assetOverview') }}</el-menu-item>
            <el-menu-item index="riderzc">{{ $t('menu.riderAsset') }}</el-menu-item>
            <el-menu-item index="shopzc">{{ $t('menu.shopAsset') }}</el-menu-item>
            <el-menu-item index="withdrawalList">{{ $t('menu.withdrawalList') }}</el-menu-item>
            <el-menu-item index="withdrawalSet">{{ $t('menu.withdrawalSet') }}</el-menu-item>
            <!-- <el-menu-item index="bondlist">保证金列表</el-menu-item>
            <el-menu-item index="bondSet">保证金设置</el-menu-item>-->
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">
            <i class="icon-col el-icon-s-data"></i>
            <span slot="title">{{ $t('menu.data') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="orderfenxi">{{ $t('menu.orderAnalysis') }}</el-menu-item>
            <el-menu-item index="riderfenxi">{{ $t('menu.riderAnalysis') }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- <el-submenu index="7">
          <template slot="title">
            <i class="icon-col el-icon-s-data"></i>
            <span slot="title">应 用</span>
          </template>
        </el-submenu>-->
        <el-menu-item index="applicationlist">
          <i class="icon-col el-icon-s-grid"></i>
          <span slot="title">{{ $t('menu.application') }}</span>
        </el-menu-item>
        <el-submenu index="8">
          <template slot="title">
            <i class="icon-col el-icon-s-tools"></i>
            <span slot="title">{{ $t('menu.settings') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="platformset">{{ $t('menu.platformSet') }}</el-menu-item>
            <el-menu-item index="agreement">{{ $t('menu.agreement') }}</el-menu-item>
            <el-menu-item index="versionupdate">{{ $t('menu.versionUpdate') }}</el-menu-item>
            <el-menu-item index="noticemanage">{{ $t('menu.noticeManage') }}</el-menu-item>
            <el-menu-item index="noticemant">{{ $t('menu.messageManage') }}</el-menu-item>
            <!-- <el-menu-item index="payment">支付设置</el-menu-item> -->
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="9" v-if="configInfo.role == 'founder'">
          <template slot="title">
            <i class="icon-col el-icon-s-tools"></i>
            <span slot="title">{{ $t('menu.permission') }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="appletlist">{{ $t('menu.appletList') }}</el-menu-item>
            <el-menu-item index="Appletlistedit">{{ $t('menu.superAuth') }}</el-menu-item>
            <el-menu-item index="empower">{{ $t('menu.empower') }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container class="cont-right">
      <div class="minWidth">
        <el-header>
          <div class="flex-bet hei">
            <div class="flex wei fon_20 pad_l_30">
              <span>{{ $t('header.welcome') }}</span>
              <el-badge :value="$t('header.platformId') + platformInfo.systemId" class="pad_r_10">{{ platformInfo.name }}</el-badge>
            </div>
            <div class="pad_r_20 flex flex-y-center">
              <span class="mar_r10 color_6">{{ $t('lang.label') }}</span>
              <el-select
                :value="currentLocale"
                size="small"
                class="mar_r20"
                style="width: 130px"
                @change="onLocaleChange"
              >
                <el-option :label="$t('lang.zhCN')" value="zh-CN" />
                <el-option :label="$t('lang.frFR')" value="fr-FR" />
              </el-select>
              <el-button type="text" class="mar_r20">
                <i class="el-icon-message-solid el-icon color_3 fon_18"></i>
              </el-button>
              <el-dropdown>
                <div class="flex-y-center">
                  <img alt="logo" src="@/assets/img/moren.png" class="yb_logo2 mar_r15 bor_rad50" />
                </div>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item>
                    <a class="color_3">个人中心</a>
                  </el-dropdown-item> -->
                  <el-dropdown-item >
										<div  @click="outLogin()">
											<a class="color_3">{{ $t('header.logout') }}</a>
										</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-header>
        <el-main>
          <router-view />
        </el-main>
        <el-footer class="ba_f">
          <div v-if="configInfo.edition == 1">
            <div class="t_c" v-if="configInfo.content">{{ configInfo.content }}</div>
            <div class="t_c" v-else>
              <p>
                <a href="#" target="_blank" class="color_3">微信开发</a>
                <a href="http://s.w7.cc/" target="_blank">微信应用</a>
                <a href="http://s.w7.cc/" target="_blank" class="color_3 mar_l20">小程序开发</a>
              </p>
              <span>Powered by</span>
              <a class="color_3 wei" href="https://www.w7.cc/" target="_blank">微擎</a>
              <span>v2.6.3 2014-2020</span>
              <a href="https://www.w7.cc/" target="_blank" class="color_3">www.w7.cc</a>
            </div>
          </div>
        </el-footer>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { getConfig } from '@/api/set.js';
import { logout } from '@/api/auth';
import { resetSessionCheck } from '@/utils/auth';
import { setAppLocale } from '@/i18n';
export default {
  name: 'public',
  data() {
    return {
      isCollapse: false,
      copy: '',
      edition: '',
      configInfo: {},
      configSetInfo: {},
      currentLocale: this.$i18n.locale,
    };
  },
  created() {
    this.getConfig();
  },
  computed: {
    ...mapState(['platformInfo'])
  },
  methods: {
    ...mapMutations(['getPlatformInfo']),
    onLocaleChange(lang) {
      setAppLocale(lang);
      this.currentLocale = lang;
      document.title = this.$t('app.title');
    },
		/**
		 * @description 退出登录
		 */
		async outLogin(){
			try {
				await logout();
			} catch (e) {
				// 忽略网络错误，仍跳转登录页
			}
			this.$store.commit('clearAuth');
			resetSessionCheck();
			this.$router.replace({ path: '/login' });
		},
		
    async getConfig() {
      const { data } = await getConfig({ ident: 'sysTopImage' });
      getConfig({ ident: 'system' }).then((res) => {
        this.getPlatformInfo(res.data);
      });
      this.configInfo = data;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    shwoHidenClick() {
      if (this.isCollapse == false) {
        this.isCollapse = true;
      } else {
        this.isCollapse = false;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.el-container {
  height: 100vh;
  overflow: hidden;

  >>>.el-aside {
    background-color: #2f3447;
    overflow: hidden;
    width: 220px !important;

    .el-menu {
      border: none;

      .icon-col {
        color: #fff;
        margin-right: 20px;
      }
    }
  }

  .hshow {
    width: 220px;
    height: 80px;
    border-right: solid 1px #e6e6e6;
    border: none !important;
    background-color: #2f3447;

    img {
      width: 193px;
      height: 30px;
    }

    span {
      flex: 1;
      min-width: 100px;
      color: #fff;
      text-align: left;
      padding-left: 10px;
      font-size: 20px;
      word-wrap: no-wrap;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .hshow_1 {
    padding: 0 20px;

    img {
      width: 30px;
      height: 30px;
    }
  }
}

.cont-right {
  overflow-x: auto;

  .minWidth {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 1200px;

    .el-header {
      padding: 0;
      background: #fff;
    }

    .el-main {
      overflow-x: hidden;
      overflow-y: auto;
    }

    .yb_logo2 {
      width: 28px;
      height: 28px;
    }

    .el-footer {
      box-shadow: 0 0 8px 0 rgba(99, 85, 85, 0.1);
      transform: rotate(0deg);
      line-height: 60px;
    }
  }
}
</style>
<style lang="scss">
.el-badge__content.is-fixed {
  top: 12px;
  right: 7px;
}
</style>
